import type { CommunityList, LabelInValue } from 'models';
import type { ReactNode } from 'react';
import { useCallback } from 'react';
import { useCommunitySelectCreateOption } from '../../community-select';

export type CommunityLabelInValue = { optionLabel: ReactNode; organization: { id: string } } & LabelInValue;

export const useCommunitySelectWithUserProfilePhotoCreateOption = () => {
  const createOption = useCommunitySelectCreateOption();

  return useCallback(
    (community: CommunityList): CommunityLabelInValue => ({
      ...createOption(community),
      organization: { id: community.organization.id },
    }),
    [createOption],
  );
};
